const endpointConfig = {
    env: process.env
};

export default endpointConfig;


// WEBPACK FOOTER //
// ./src/endpointConfig.js